/**
 * MotoristaResponsavelCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {MotoristaResponsavel} from '@/model/resource/MotoristaResponsavel'

/* TODO: review generated class */
@HttpExclude()
export class MotoristaResponsavelCollection extends PageCollection<
  MotoristaResponsavel
> {
  constructor() {
    super(MotoristaResponsavel)
  }

  queryAsPage() {
    return this.listMotoristaResponsavel()
  }

  async listMotoristaResponsavel() {
    return await Request.get(`/admin/motorista-responsavel`, {
      params: this.params,
    })
      .name('listMotoristaResponsavel')
      .as(this)
      .getResponse()
  }

  async listCsvMotoristaResponsavel() {
    return await Request.get(`/admin/motorista-responsavel/csv`, {
      params: this.params,
    })
      .name('listCsvMotoristaResponsavel')
      .as(this)
      .getResponse()
  }
}
